
import {Component, Emit, Mixins, Prop} from 'vue-property-decorator';
import CatalogEntryMixin from './CatalogEntryMixin.ts';
import ProgressIndicator from './indicators/ProgressIndicator';
import CatalogMiniature from 'src/modules/catalog/components/cards/parts/CatalogMiniature.vue';

@Component({
  components: {
  CatalogMiniature,
  ProgressIndicator,
  },
  })
export default class CatalogCard extends Mixins(CatalogEntryMixin) {
  @Prop({required: true}) width!: string;
  @Prop({default: false}) withBlackFilter!: boolean;
  @Prop({default: false}) emitClick!: boolean
}
